const combineCallingCodeWithCountry = (item: {
  phoneCountryCode: string;
  id: string;
}) => item.phoneCountryCode + "-" + item.id;

const splitCallingCodeAndCountry = (str: string) => str.split("-");

export { combineCallingCodeWithCountry, splitCallingCodeAndCountry };
